/**
 * Bring the selected item of a scrollable list into view, centered when possible.
 * Used by the recorder side panels, which open on a selection made earlier.
 */
export const scrollToSelectedItem = (container: HTMLElement | null | undefined,
                                     selector: string = '.selected') => {
    if (!container) {
        return;
    }
    const selected = container.querySelector(selector) as HTMLElement | null;
    if (!selected) {
        return;
    }
    const target = selected.offsetTop - (container.clientHeight / 2) + (selected.clientHeight / 2);
    container.scrollTop = Math.max(0, target);
};
